import React from "react"
import PropTypes from "prop-types"
import { connect }  from 'react-redux'
import NumericInput from 'react-numeric-input'

class VisitLineItems extends React.Component {
  formatValue = (value) => {
    return `${(value / 100).toFixed(2).replace(".", ",")}`
  }

  render () {
    let numericInputGenerator = (field, fieldText, disabled) => {
      return (
        <td className="text-center">
          <input
            disabled={disabled}
            className="form-control"
            id={"visit_line_items_attributes_" + this.props.lineItem.id + "_" + field}
            name={"visit[line_items_attributes][" + this.props.lineItem.id + "][" + field + "]"}
            onChange={event => this.props.changeLineItem(this.props.lineItem.id, field, event.target.value)}
            value={this.props.lineItem[field]}
            size={4} />
        </td>
      )
    }

    let inputLineItemId = (lineItem, edit) => {
      if (edit) {
        return (
          <input
            className="form-control"
            type="hidden"
            id={"visit_line_items_attributes_" + this.props.lineItem.id + "_id"}
            name={"visit[line_items_attributes][" + this.props.lineItem.id + "][id]"}
            value={this.props.lineItem.id}
          />
        )
      }
    }

    let disabled = this.props.edit ? false : true

    return (
      <React.Fragment>
        <tr>
          <td>
            <span className={this.props.lineItem.selectedProduct.style}>
              {this.props.lineItem.selectedProduct.name}
            </span>
            <input
              className="form-control"
              type="hidden"
              id={"visit_line_items_attributes_" + this.props.lineItem.id + "_product_id"}
              name={"visit[line_items_attributes][" + this.props.lineItem.id + "][product_id]"}
              value={this.props.lineItem.selectedProduct.id}
              />
            {inputLineItemId(this.props.lineItem, this.props.edit)}
          </td>
          <td className="text-right">
            {this.formatValue(this.props.lineItem.selectedProduct.price_cents)}
          </td>
          {numericInputGenerator("quantity", "Τμχ", false)}
          {numericInputGenerator("discount", "Έκπτ", false)}
          {numericInputGenerator("gift", "Δώρο", false)}
          {numericInputGenerator("stock", "Στοκ", false)}
          {numericInputGenerator("invoiced", "Τιμόλ", disabled)}
        </tr>
      </React.Fragment>
    );
  }
}

const mapState = state => {
  return {
    lineItems: state.lineItems,
    edit: state.edit
  }
}

const mapDispatch = dispatch => {
  return {
    changeLineItem: (lineItemId, field, value) => dispatch({type: 'CHANGE_LINE_ITEM', lineItemId: lineItemId, field: field, value: value})
  }
}

export default connect(mapState, mapDispatch)(VisitLineItems)
